<template>
  <div id="audience">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'news'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/question/Question.vue